import { gql } from 'urql';
import { PRODUCT } from '../client';

export const UPDATE_LOCATIONS_SERVICE_TIME = gql`
  mutation ${PRODUCT}UpdateLocationsServiceTime($input: LocationsServiceTimeUpdateInput!) {
    updateLocationsServiceTime(input: $input) {
      locations {
        id
        serviceTime
      }
    }
  }
`;
